import React from 'react'
import { getImage } from '../shared/customization';

export default function Spinner() {
  return (
    <div 
    className='bg-black opacity-50 flex items-center justify-center fixed right-0 left-0 top-0 bottom-0 z-50'>
      <div>
        <img src={getImage('Spinner')} alt="Loading..." />
      </div>
    </div>
  )
}
